import _classCallCheck from '/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createClass';
import _createSuper from '/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createSuper';
import _inherits from '/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/inherits';
/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module font/fontbackgroundcolor/fontbackgroundcolorui
 */
import ColorUI from '../ui/colorui';
import { FONT_BACKGROUND_COLOR } from '../utils';
import fontBackgroundColorIcon from '../../theme/icons/font-background.svg';
/**
 * The font background color UI plugin. It introduces the `'fontBackgroundColor'` dropdown.
 *
 * @extends module:core/plugin~Plugin
 */
var FontBackgroundColorUI = /*#__PURE__*/
function (_ColorUI) {
    _inherits(FontBackgroundColorUI, _ColorUI);
    var _super = _createSuper(FontBackgroundColorUI);
    /**
   * @inheritDoc
   */
    function FontBackgroundColorUI(editor) {
        _classCallCheck(this, FontBackgroundColorUI);
        var t = editor.locale.t;
        return _super.call(this, editor, {
            commandName: FONT_BACKGROUND_COLOR,
            componentName: FONT_BACKGROUND_COLOR,
            icon: fontBackgroundColorIcon,
            dropdownLabel: t('Couleur d\'arrière-plan')
        });
    }
    /**
   * @inheritDoc
   */
    _createClass(FontBackgroundColorUI, null, [{
            key: 'pluginName',
            get: function get() {
                return 'FontBackgroundColorUI';
            }
        }]);
    return FontBackgroundColorUI;
}(ColorUI);
export {
    FontBackgroundColorUI as default
};